import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { QueryFilter, QUERY_FILTER_CONSULTING_PUBLISHER, Filter } from 'src/component/shared';
import { client } from 'src';

import { Header, Navigation, Footer } from '../../shared';
import { Grid, Typography, Tab, AppBar, Tabs, Paper, Snackbar } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';

import './ConsultingPublisher.scss';
import { ConsultingPublisherSalesEvolution } from './salesEvolution/ConsultingPublisherSalesEvolution';
import { ConsultingPublisherCategory } from './categoryEvolution/ConsultingPublisherCategory';
import { ConsultingPublisherCategoryBestPlayers } from './categoryBestPlayers/ConsultingPublisherCategoryBestPlayers';
import { ConsultingPublisherPeriodFilter } from './shared/filter/period/ConsultingPublisherPeriodFilter';
import { ConsultingPublisherFilter } from './shared/filter/publisher/ConsultingPublisherFilter';
import { ConsultingPublisherChip } from './shared/chips/ConsultingPublisherChip';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { ConsultingPublisherBisacFilter } from './shared/filter/bisac/ConsultingPublisherBisacFilter';

const CONSULTING_PUBLISHER_SALES_EVOLUTION = gql`
query consultingPublisherSalesEvolution($customFilter:  ConsultingPublisherCustomFilter) {
    consultingPublisherSalesEvolution(consultingPublisherCustomFilter: $customFilter) {
      origin,
      billing_evolution,
      volume_evolution
  }
}
`;

const QUERY_GET_INITIAL_BISACS = gql`
query { consultingPublisherBisacFilterBestSelled { id, bisac, description } }
`;

const QUERY_FILE_REPORT = gql`
query consultingPublisherReport($customFilter:  ConsultingPublisherCustomFilter) {
  consultingPublisherReport(consultingPublisherCustomFilter: $customFilter)
}
`;

// tslint:disable-next-line:no-empty-interface
export interface IConsultingPublisherProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IConsultingPublisherState {
  customFilter: {
    isChart: boolean
  },
  initialBisacsChecked: string[],
  openSnack: boolean,
  snackMessage: string,
  tabValue: number,
}

function TabContainer(props: any) {
  return (
      <Typography component="div" style={{ paddingTop: 8 * 3 }}>
          {props.children}
      </Typography>
  );
}

function LinkTab(props: any) {
  return (
    // tslint:disable-next-line:jsx-no-lambda
    <Tab component="a" onClick={event => event.preventDefault()} {...props} />
  );
}

export class ConsultingPublisher extends React.Component<IConsultingPublisherProps, IConsultingPublisherState> {
  constructor(props: IConsultingPublisherProps) {
    super(props);
    this.state = {
      customFilter: {
        isChart: true,
      },
      initialBisacsChecked: [],
      openSnack: false,
      snackMessage: '',
      tabValue: 0,
    }

    this.handleSnackClose = this.handleSnackClose.bind(this);
  }

  public async componentWillMount () {

    client.query({
      query: QUERY_GET_INITIAL_BISACS
    }).then( (result:any)  => {
        if(result != null && result !== undefined 
            && result.data != null && result.data !== undefined && result.data != null && result.data !== undefined
            && result.data.consultingPublisherBisacFilterBestSelled != null && result.data.consultingPublisherBisacFilterBestSelled !== undefined 
            && result.data.consultingPublisherBisacFilterBestSelled.length > 0) {

              const bisacs = result.data.consultingPublisherBisacFilterBestSelled.map(( item:any ) => item.description);

              client.writeData({ data: { consultingPublisherBisacFilterChecked: bisacs } });
              client.writeData({ data: { FILTER_consultingPublisherBisacFilterChecked: bisacs } });

              this.setState({ initialBisacsChecked: bisacs });
              return;

        }
    });
  }


  public render() {
    let jsonFilter : any = {
      "customFilter": {
        "isChart": this.state.customFilter.isChart,
      }
    };
    let filterCompare : any = {
      "customFilter": {
        "isChart": this.state.customFilter.isChart,
      }
    };
    const showBisac = this.state.tabValue !== 0;

    const filters :any[] = [
      <ConsultingPublisherFilter key={1} />,
      <ConsultingPublisherPeriodFilter key={3} />
    ];

    if(showBisac) {
      filters.push(<ConsultingPublisherBisacFilter key={4} initialBisacsChecked={this.state.initialBisacsChecked} />);
    }

    return (
      <div>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={this.state.openSnack}
          onClose={this.handleSnackClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{this.state.snackMessage}</span>}
        />
        <Header
          title={"Análises"}
          name={"Consultoria Editora"}
          link={'/dashboard'}
        />
        <Navigation
            name={"Consultoria Editora"}
            linkDefault={"/consulting/publisher"}
            link={"/dashboard"}
            linkTitle={"Produtos"}
            painel={3}
            icon={<ChevronRightIcon />}
        />

        <Filter filters={filters} />

        <ConsultingPublisherChip showBisac={showBisac} />

        <div className="wrapper">
          <Query query={QUERY_FILTER_CONSULTING_PUBLISHER} notifyOnNetworkStatusChange={true}  >
              {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                  filterCompare = QueryFilter.getFilterConsultingPublisher(clientC, filterCompare, [], false);
                  jsonFilter = QueryFilter.getFilterConsultingPublisher(clientC, jsonFilter, ['bisacs'], false);

                  return (
                    <div>
                      <AppBar position="static" style={{ backgroundColor: '#FFFF' }}>
                        <Tabs fullWidth={true} value={this.state.tabValue} onChange={this.handleChangeTab} centered={true}
                          textColor="primary" indicatorColor="primary">
                          <LinkTab label="Consolidado" href="page1" />
                          <LinkTab label="Categorias" href="page2" />
                          <Tab icon={<GetAppIcon />} onClick={this.requestFile.bind(this, clientC, filterCompare)} />
                        </Tabs>
                      </AppBar>
                      {(
                        filterCompare.customFilter.period == null || filterCompare.customFilter.period === undefined || filterCompare.customFilter.period.length === 0
                        || filterCompare.customFilter.publishers == null || filterCompare.customFilter.publishers === undefined || filterCompare.customFilter.publishers.length === 0
                      ) ? 
                          <Paper className='requiredFilterPaper' >
                              <Typography align="center" variant="title" className='requiredFilterMessage'>
                                  Escolha um Fornecedor e um período
                              </Typography>
                          </Paper> 
                        : 
                          <div>
                            {this.state.tabValue === 0 && <TabContainer>
                                <Query query={CONSULTING_PUBLISHER_SALES_EVOLUTION} variables={jsonFilter}>
                                    {({ loading, error, data }) => {
                                        return (
                                          <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16}>
                                              <Grid item={true} xs={6}>
                                                <ConsultingPublisherSalesEvolution loading={loading} data={data} type='VOLUME' title='Evolução Volume' />
                                              </Grid>
                            
                                              <Grid item={true} xs={6}>
                                                <ConsultingPublisherSalesEvolution loading={loading} data={data} type='FATURAMENTO' title='Evolução Faturamento' />
                                              </Grid>
                                          </Grid>
                                        );
                                    }}
                                </Query>
                            </TabContainer>}

                            {this.state.tabValue === 1 && <TabContainer>
                                {filterCompare.customFilter.bisacs == null || filterCompare.customFilter.bisacs === undefined || filterCompare.customFilter.bisacs.length === 0 ? 
                                    <Paper className='requiredFilterPaper' >
                                        <Typography align="center" variant="title" className='requiredFilterMessage'>
                                            Escolha uma Categoria
                                        </Typography>
                                    </Paper> : 
                                    <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16}>
                                        <Grid item={true} xs={12} md={12}>
                                            <ConsultingPublisherCategory />
                                        </Grid>
                                        <Grid item={true} xs={12} md={12}>
                                            <ConsultingPublisherCategoryBestPlayers />
                                        </Grid>
                                    </Grid>
                                }
                            </TabContainer>}
                        </div>
                      }
                    </div>
                  );
              }}
          </Query>
        </div>
        <Footer />
      </div>
    );
  }

  private handleChangeTab = (event: any, tabValue: any) => {
      if(tabValue !== 2) {
          this.setState({ tabValue });
      }
  };

  private requestFile(clientR: any, filter: any) {
    let message = "O relatório está sendo preparado para download";
    if(filter.customFilter.period == null || filter.customFilter.period === undefined || filter.customFilter.period.length === 0) {
      message = "É necessário informar um período";
    } else if (filter.customFilter.publishers == null || filter.customFilter.publishers === undefined || filter.customFilter.publishers.length === 0) {
      message = "É necessário informar um fornecedor";
    } else if (filter.customFilter.bisacs == null || filter.customFilter.bisacs === undefined || filter.customFilter.bisacs.length === 0) {
      message = "É necessário informar ao menos uma categoria";
    } else {
      clientR.query({
        fetchPolicy: 'network-only',
        query: QUERY_FILE_REPORT,
        variables: filter
      }).then((data:any) => {
        console.log('data: '+JSON.stringify(data));
      });
    }
    this.setState({
      openSnack: true,
      snackMessage: message,
    });
  }

  private handleSnackClose(ev: any) {
    this.setState({
      openSnack: false,
    });
  }

}



// WEBPACK FOOTER //
// ./src/component/consulting/publisher/ConsultingPublisher.tsx